import { Checkbox, Chip, MenuItem, Tooltip } from "@mui/material";
import ListItemText, { type ListItemTextProps } from "@mui/material/ListItemText";
import { TAGS_FAMILY_SEPARATOR } from "../../AssetsFilterTags.constants";
import type { TagMenuItemProps } from "../../AssetsFilterTags.types";

const ITEM_TEXT_SLOT_PROPS: ListItemTextProps["slotProps"] = {
  primary: {
    className: "truncate pr-3",
  },
};

export default function TagMenuItem({
  tag,
  isStandalone = false,
  isSelected,
  onToggle,
}: TagMenuItemProps) {
  const displayName = isStandalone
    ? tag.name
    : tag.name.split(TAGS_FAMILY_SEPARATOR)[1];

  return (
    <MenuItem
      key={tag.tag_id}
      value={tag.tag_id}
      sx={{ py: 0 }}
      onClick={() => onToggle(tag.tag_id)}
    >
      <Checkbox checked={isSelected} size="small" sx={{ pl: 0 }} />

      <ListItemText slotProps={ITEM_TEXT_SLOT_PROPS} primary={displayName} />

      <Tooltip
        title="Number of assets with this tag"
        enterDelay={500}
        enterNextDelay={500}
        disableInteractive
        arrow
      >
        <Chip size="small" label={tag.cnt} />
      </Tooltip>
    </MenuItem>
  );
}
